<template>
    <div>
       <vue-apex-charts ref="chart" type="boxPlot" :options="chartOptions" :series="series" height="250"></vue-apex-charts>
    </div>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'
import LocationTypeEnum from "../../LocationTypeEnum.js";

export default {
  name:"GradeBoxPlot",  
  components: {
    VueApexCharts
  },
  props: {
    mesuredElement: {
      type: Number,
      required: false,
      default : 0
    },
    title: {
      type: String,
      default : ''
    }
  },
  data() {
    return {
      series: [
        {
          type: 'boxPlot',
          data: []
        }
      ],
      chartOptions: {
        chart: {
          type: 'boxplot'
        },
        title: {
          text: ""
        },
        yAxis: {
          title: {
            text: this.$systemUnits.getGradeUnitLabel()
          },
          min: 0
        },
        plotOptions: {
          boxPlot: {
            colors: {
              upper: '#ffcf01',
              lower: '#48638f'
            }
          }
        }
      },
      sampleElementsStats: [],
      locationElementStats: [],
      locationCode: "",
      sampleNumber: ""
    };
  },
  watch: {
    mesuredElement() {
      this.updateChart();
    }
  },
  methods: {
    fillDatas(locationStats, sampleStats, sampleNumber) {
      if (locationStats && sampleStats) {
        this.locationElementStats = [];
        this.locationCode = ""
        this.sampleElementsStats = [];
        this.sampleNumber = sampleNumber;
        if (locationStats[0]) {
          //Add location stats
          locationStats.forEach(stat => {          
            stat.elementsGradeStats.forEach(elementStat => {
              const yData = [
                this.getGrade(elementStat.minGrade, elementStat.element),
                this.getGrade(elementStat.lowerQuantile, elementStat.element),
                this.getGrade(elementStat.medianGrade, elementStat.element),
                this.getGrade(elementStat.upperQuantile, elementStat.element),
                this.getGrade(elementStat.maxGrade, elementStat.element)
              ];
              this.locationElementStats.push(yData);
            });
            const typeDef = LocationTypeEnum.getSuffix(stat.locationType);
            this.locationCode = stat.locationCode + "-" + typeDef;
          });
        }
        //Add sample stats
        sampleStats.forEach(stat => {
          const ydata = [
            this.getGrade(stat.minGrade, stat.element),
            this.getGrade(stat.lowerQuantile, stat.element),
            this.getGrade(stat.medianGrade, stat.element),
            this.getGrade(stat.upperQuantile, stat.element),
            this.getGrade(stat.maxGrade, stat.element)
          ];
          this.sampleElementsStats.push(ydata);
        });

        this.updateChart();
      }
    },
    getGrade(value, element) {
      return this.$options.filters.toFriendlyGrade(this.$systemUnits.convertGrade(value, element));
    },
    updateChart() {
      const datas = [];

      if (this.locationCode) {
        const locationData = {
          x: this.locationCode,
          y: this.locationElementStats[this.mesuredElement]
        }
        datas.push(locationData);
      }
      
      const sampleData = {
        x: this.sampleNumber,
        y: this.sampleElementsStats[this.mesuredElement]
      }
      datas.push(sampleData);

      this.$refs.chart.updateSeries([{ data: datas }], false, true);

      //Updated y axis label
      const annotations = { yaxis: [] };
      const yaxis = {
        type: 'numeric',
        title: {
          text: this.$systemUnits.getGradeUnitLabel()
        }
      }

      if (this.mesuredElement > 1) {
        yaxis.title.text = '%'
      }
        
      this.$refs.chart.updateOptions({ annotations, yaxis });
    }
  }
};
</script>
